<div class="avatar-group">
  @for (user of visibleUsers; track user) {
    <ng-container *ngTemplateOutlet="avatarTemplate || defaultAvatar; context: { $implicit: user, size: size }"></ng-container>
  }
  @if (hasOverflow) {
    <p-avatar
      class="avatar-group-item avatar-group-overflow"
      [label]="'+' + overflowCount"
      shape="circle"
      [size]="size"
      pTooltip="Show all"
      tooltipPosition="bottom"
      (click)="dialogVisible = true"
    ></p-avatar>
  }
</div>

<p-dialog
  header="Collaborators"
  [(visible)]="dialogVisible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [draggable]="false"
  appendTo="body"
  >
  <div class="user-list" role="list">
    @for (user of users; track user) {
      <div class="user-list-item" role="listitem">
        <ng-container *ngTemplateOutlet="avatarTemplate || defaultAvatar; context: { $implicit: user, size: size }"></ng-container>
        <div class="user-list-item-info">
          <span>{{ user.displayName }}</span>
          <span class="user-list-item-email">{{ user.email }}</span>
        </div>
      </div>
    }
  </div>
</p-dialog>

<ng-template #defaultAvatar let-user let-size="size">
  <user-avatar [user]="user" [size]="size"></user-avatar>
</ng-template>
